export default "__VITE_ASSET__bb1bb868__"